export default ({
  namespaced: true,

  state: {
    item: JSON.parse(localStorage.getItem('promoItem') || '{}'),
    // user entered code for this plan
    planStorage: JSON.parse(localStorage.getItem('promoPlan')),
    planLocal: null
  },
  
  getters: {
    item: state => state.item,
    quantity: state => {
      return state.item.quantity
    },
    total: state => {
      return state.item.quantity * state.item.price
    },
    plan: state => {
      return state.planStorage || state.planLocal
    },
    memberQuantity: state => state.item.memberQuantity,
    member: state => state.item.member
  },

  mutations: {
    setItem(state, {description, discount, id, name, price, quantity, member, memberQuantity, maxDependents}) {
      state.item = {
        description: description,
        discount: discount,
        id: id,
        name: name,
        price: price,
        quantity: quantity,
        member: member,
        memberQuantity: memberQuantity,
        maxDependents: maxDependents
      }
      localStorage.setItem('promoItem', JSON.stringify(state.item));
    },
    deleteItem(state) {
      state.item = {};
      localStorage.setItem('promoItem', JSON.stringify(state.item));
      state.planLocal = null;
      state.planStorage = null;
      localStorage.removeItem('promoPlan');
    },
    increaseQuantity(state) {
      // if (state.item.quantity <= 99) {
      if (state.item.quantity) {
        state.item.quantity++;
        localStorage.setItem('promoItem', JSON.stringify(state.item));
      }
    },
    decreaseQuantity(state) {
      if (state.item.quantity >= 2) {
        state.item.quantity--;
        localStorage.setItem('promoItem', JSON.stringify(state.item));
      }
    },
    setQuantity(state, quantity) {
      // if (state.item.quantity <= 100) {
      // if (state.item.quantity) {
      if (quantity <= 0 || state.item.quantity <= 0) {
        state.item.quantity = ''
        state.item.quantity = 1
        // localStorage.setItem('item', JSON.stringify(state.item));
      }
      else {
        state.item.quantity = quantity;
        localStorage.setItem('promoItem', JSON.stringify(state.item));
      }
      // }
    },
    setCurrentPlan(state, plan) {
      console.log(plan)
      state.planLocal = plan
    },
    removeCurrentPlan(state) {
      state.planLocal = null
    },
    increaseMemberQuantity(state) {
      state.item.memberQuantity++;
      localStorage.setItem('promoItem', JSON.stringify(state.item));
    },
    decreaseMemberQuantity(state) {
      if (state.item.memberQuantity >= 1) {
        state.item.memberQuantity--;
        localStorage.setItem('promoItem', JSON.stringify(state.item));
      }
    },
    setMemberQuantity(state, quantity) {
      if (state.item.memberQuantity >= 0) {
        state.item.memberQuantity = quantity;
        localStorage.setItem('promoItem', JSON.stringify(state.item));
      }
    }
  },

  actions: {
    //
  }
})